export const Mutations = {
    updaterSetLastTimestamp(state, timestamp) {
        state.lastTimestamp = timestamp;
    },
}
